import isNumber from "lodash-es/isNumber"
import round from "lodash-es/round"

const kzkWdgt = {
    entity: null,
    audioEpisodeId: null,
    audioEpisodeTitle: null,
    audioEpisodeDuration: null,
    audioCycleId: null,
    articleId: null,
    issueArticleId: null,
    issueId: null,
    audioPlayer: null,
    playPause: null,
    playPauseBtn: null,
    loading: null,
    controls: null,
    progress: null,
    progressSlider: null,
    volumeSlider: null,
    volume: null,
    volumeBtn: null,
    volumeControls: null,
    volumeProgress: null,
    player: null,
    playerSource: null,
    currentTime: null,
    totalTime: null,
    speaker: null,
    currentlyDragged: false,
    alreadyPlayed: false,
    playList: null,
    stats: {},
    afterEnd: false,
    isDemoTrack: false,

    init: function (entity) {
        window.onbeforeunload = function () {
            kzkWdgt.sendStats();
        };

        kzkWdgt.entity = entity;
        kzkWdgt.audioPlayer = document.querySelector('#kiozk-audio-player');
        if (kzkWdgt.audioPlayer === null) {
            return;
        }
        kzkWdgt.playList = kzkWdgt.audioPlayer.querySelector('.playlist');
        kzkWdgt.audioCycleId = Number(kzkWdgt.audioPlayer.getAttribute('data-cycle-id'));
        kzkWdgt.articleId = Number(kzkWdgt.audioPlayer.getAttribute('data-article-id'));
        kzkWdgt.issueArticleId = Number(kzkWdgt.audioPlayer.getAttribute('data-issue-article-id'));
        kzkWdgt.issueId = Number(kzkWdgt.audioPlayer.getAttribute('data-issue-id'));
        kzkWdgt.playPause = kzkWdgt.audioPlayer.querySelector('#play-pause');
        kzkWdgt.playPauseBtn = kzkWdgt.audioPlayer.querySelector('.play-pause-btn');
        kzkWdgt.loading = kzkWdgt.audioPlayer.querySelector('.loading');
        kzkWdgt.controls = document.getElementById('controls');
        kzkWdgt.progress = kzkWdgt.audioPlayer.querySelector('.kiozk-progress');
        kzkWdgt.progressSlider = kzkWdgt.audioPlayer.querySelector('.progress-slider');
        kzkWdgt.volumeSlider = kzkWdgt.audioPlayer.querySelector('#volume-slider');
        kzkWdgt.volume = kzkWdgt.audioPlayer.querySelector('.volume');
        kzkWdgt.volumeBtn = kzkWdgt.audioPlayer.querySelector('.volume-btn');
        kzkWdgt.volumeControls = kzkWdgt.audioPlayer.querySelector('.volume-controls');
        kzkWdgt.volumeProgress = kzkWdgt.volumeControls.querySelector('.slider .kiozk-progress');
        kzkWdgt.player = kzkWdgt.audioPlayer.querySelector('audio');
        kzkWdgt.playerSource = kzkWdgt.audioPlayer.querySelector('source');
        kzkWdgt.audioEpisodeId = Number(kzkWdgt.playerSource.getAttribute('data-id'));
        kzkWdgt.audioEpisodeTitle = kzkWdgt.playerSource.getAttribute('data-title');
        kzkWdgt.currentTime = kzkWdgt.audioPlayer.querySelector('.current-time');
        kzkWdgt.totalTime = kzkWdgt.audioPlayer.querySelector('.total-time');
        kzkWdgt.speaker = kzkWdgt.audioPlayer.querySelector('#speaker');

        let totalTimeValue = kzkWdgt.totalTime.innerText;
        if (totalTimeValue.indexOf(':') < 0) {
            let totalTimeFloatValue = parseFloat(totalTimeValue);
            if (!isNaN(totalTimeFloatValue)) {
                kzkWdgt.totalTime.innerHTML = kzkWdgt.formatTime(0 - totalTimeFloatValue);
            }
        }


        window.addEventListener('mousedown', function (event) {
            let handleMethod = kzkWdgt.getDraggableMethod(event.target);
            if (handleMethod === '') {
                return false;
            }

            kzkWdgt.currentlyDragged = event.target;

            this.addEventListener('mousemove', kzkWdgt[handleMethod], false);

            window.addEventListener('mouseup', function () {
                kzkWdgt.currentlyDragged = false;
                window.removeEventListener('mousemove', kzkWdgt[handleMethod], false);
            }, false);
        });

        document.body.addEventListener('touchstart', function (event) {
            let handleMethod = kzkWdgt.getDraggableMethod(event.target);
            if (handleMethod === '') {
                return false;
            }

            kzkWdgt.currentlyDragged = event.target;

            this.addEventListener('touchmove', kzkWdgt[handleMethod], false);

            document.body.addEventListener('touchend', function () {
                kzkWdgt.currentlyDragged = false;
                document.body.removeEventListener('touchmove', kzkWdgt[handleMethod], false);
            }, false);
        });

        kzkWdgt.playPauseBtn.addEventListener('click', kzkWdgt.togglePlay);
        kzkWdgt.player.addEventListener('timeupdate', kzkWdgt.updateProgress);
        kzkWdgt.player.addEventListener('volumechange', kzkWdgt.updateVolume);
        kzkWdgt.player.addEventListener('loadedmetadata', function () {
            kzkWdgt.totalTime.textContent = kzkWdgt.formatTime(kzkWdgt.player.duration);
        });
        kzkWdgt.player.addEventListener('canplay', () => {
            if (kzkWdgt.afterEnd) {
                return;
            }
            kzkWdgt.makePlay();
            kzkWdgt.play(kzkWdgt.audioEpisodeId, kzkWdgt.audioEpisodeTitle, kzkWdgt.audioEpisodeDuration);
        });
        kzkWdgt.player.addEventListener('ended', function () {
            kzkWdgt.pause(kzkWdgt.audioEpisodeId, kzkWdgt.audioEpisodeTitle);
            kzkWdgt.player.currentTime = 0;
            kzkWdgt.afterEnd = true;

            KIOSK.openModal(kzkWdgt.playerSource.getAttribute('data-demo-content'));

        });

        kzkWdgt.player.addEventListener('error', function (e) {
            kzkWdgt.makePlay();
            kzkWdgt.pause(kzkWdgt.audioEpisodeId, kzkWdgt.audioEpisodeTitle);

            if (
                e.target.error !== undefined
                && e.target.error.code === e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED
            ) {
                KIOSK.openModal(kzkWdgt.playerSource.getAttribute('data-paywall'));
            }
        }, true);

        kzkWdgt.volumeBtn.addEventListener('click', function () {
            kzkWdgt.volumeBtn.classList.toggle('open');
            kzkWdgt.volumeControls.classList.toggle('hidden');
        });

        kzkWdgt.progressSlider.addEventListener('click', kzkWdgt.rewind);
        kzkWdgt.volumeSlider.addEventListener('click', kzkWdgt.changeVolume);

        if (kzkWdgt.isIos()) {
            kzkWdgt.volume.style.display = 'none';
        }
    },

    getDraggableMethod: function (el) {
        let method = '';

        if (el.classList !== null && el.classList !== undefined) {
            for (var i = 0; i < el.classList.length; ++i) {
                if (el.classList[i] === 'draggable-rewind') {
                    method = 'rewind';
                }

                if (el.classList[i] === 'draggable-volume') {
                    method = 'changeVolume';
                }
            }
        }

        return method;
    },

    isDraggable: function (el) {
        for (var i = 0; i < el.classList.length; ++i) {
            if (el.classList[i] === 'draggable-rewind' || el.classList[i] === 'draggable-volume') {
                return true;
            }
        }
        return false;
    },

    getXPos: function (event) {
        let x = event.clientX;
        if (x === undefined) {
            x = event.changedTouches[0].clientX;
        }

        return x;
    },

    inRange: function (event) {
        let rangeBox = kzkWdgt.getRangeBox(event);
        let rect = rangeBox.getBoundingClientRect();
        let min = rect.left;
        let max = min + rangeBox.offsetWidth;
        let x = kzkWdgt.getXPos(event);

        return !(x < min || x > max);
    },

    updateProgress: function () {
        let current = kzkWdgt.player.currentTime;
        let percent = current / kzkWdgt.player.duration * 100;

        kzkWdgt.progress.style.width = percent + '%';

        kzkWdgt.currentTime.textContent = kzkWdgt.formatTime(current);
        kzkWdgt.totalTime.textContent = kzkWdgt.formatTime(current - kzkWdgt.player.duration);

        if (kzkWdgt.stats[kzkWdgt.audioEpisodeId] !== undefined && kzkWdgt.stats[kzkWdgt.audioEpisodeId]['max_time'] < kzkWdgt.player.currentTime) {
            kzkWdgt.stats[kzkWdgt.audioEpisodeId]['max_time'] = kzkWdgt.player.currentTime;
        }

        if (kzkWdgt.playList !== null) {
            let currentTrack = kzkWdgt.playList.querySelector('.track[data-episode-id="' + kzkWdgt.audioEpisodeId + '"]');
            let progress = currentTrack.querySelector('.kiozk-progress');
            let currentTime = currentTrack.querySelector('.current-time');
            let totalTime = currentTrack.querySelector('.total-time');

            progress.style.width = percent + '%';
            currentTime.textContent = kzkWdgt.formatTime(current);
            totalTime.textContent = kzkWdgt.formatTime(current - kzkWdgt.player.duration);
        }


    },

    updateVolume: function () {
        kzkWdgt.volumeProgress.style.width = kzkWdgt.player.volume * 100 + '%';
        if (kzkWdgt.player.volume >= 0.5) {
            kzkWdgt.speaker.attributes.d.value = 'M14.667 0v2.747c3.853 1.146 6.666 4.72 6.666 8.946 0 4.227-2.813 7.787-6.666 8.934v2.76C20 22.173 24 17.4 24 11.693 24 5.987 20 1.213 14.667 0zM18 11.693c0-2.36-1.333-4.386-3.333-5.373v10.707c2-.947 3.333-2.987 3.333-5.334zm-18-4v8h5.333L12 22.36V1.027L5.333 7.693H0z';
        } else if (kzkWdgt.player.volume < 0.5 && kzkWdgt.player.volume > 0.05) {
            kzkWdgt.speaker.attributes.d.value = 'M0 7.667v8h5.333L12 22.333V1L5.333 7.667M17.333 11.373C17.333 9.013 16 6.987 14 6v10.707c2-.947 3.333-2.987 3.333-5.334z';
        } else if (kzkWdgt.player.volume <= 0.05) {
            kzkWdgt.speaker.attributes.d.value = 'M0 7.667v8h5.333L12 22.333V1L5.333 7.667';
        }
    },

    getRangeBox: function (event) {
        let rangeBox = event.target;
        let el = this.currentlyDragged;
        if (
            event.type === 'click' && kzkWdgt.isDraggable(event.target)
            || event.type === 'touchstart' && kzkWdgt.isDraggable(event.target)
        ) {
            rangeBox = event.target.parentElement.parentElement;
        }
        if (event.type === 'mousemove' || (event.type === 'touchmove' && kzkWdgt.isDraggable(event.target))) {
            rangeBox = el.parentElement.parentElement;
        }
        return rangeBox;
    },

    getCoefficient: function (event) {
        let slider = kzkWdgt.getRangeBox(event);
        let rect = slider.getBoundingClientRect();
        let x = kzkWdgt.getXPos(event);
        let offsetX = x - rect.left;
        let width = slider.clientWidth;

        return offsetX / width;
    },

    rewind: function (event) {
        if (kzkWdgt.inRange(event)) {
            if (kzkWdgt.player.paused) {
                kzkWdgt.player.load();
                let callback = function () {
                    kzkWdgt.player.currentTime = kzkWdgt.player.duration * kzkWdgt.getCoefficient(event);
                    kzkWdgt.player.removeEventListener('canplay', callback);
                }
                kzkWdgt.player.addEventListener('canplay', callback);
            } else {
                kzkWdgt.player.currentTime = kzkWdgt.player.duration * kzkWdgt.getCoefficient(event);
            }
        }
    },

    changeVolume: function (event) {
        if (kzkWdgt.inRange(event)) {
            kzkWdgt.player.volume = kzkWdgt.getCoefficient(event);
        }
    },

    formatTime: function (time) {
        if (!isFinite(time)) {
            return '0:00';
        }

        let minus = '';
        if (time < 0) {
            minus = '-';
        }
        time = Math.abs(time);
        if (time >= 3600) {
            let hour = Math.floor(time / 3600);
            let mins = Math.floor(time % 3600);
            let min = Math.floor(mins / 60);
            let sec = Math.floor(mins % 60);

            return minus + hour + ':' + (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
        } else {
            let min = Math.floor(time / 60);
            let sec = Math.floor(time % 60);

            return minus + min + ':' + (sec < 10 ? '0' + sec : sec);
        }
    },

    togglePlay: function () {
        if (kzkWdgt.playerSource.getAttribute('data-auth') !== '') {
            KIOSK.openModal(kzkWdgt.playerSource.getAttribute('data-auth'));
            return;
        }

        if (kzkWdgt.player.getAttribute('src') === '' || kzkWdgt.player.getAttribute('src') === null ) {
            let id = kzkWdgt.playerSource.getAttribute('data-id');
            let title = kzkWdgt.playerSource.getAttribute('data-title');
            let duration = kzkWdgt.playerSource.getAttribute('data-duration');

            kzkWdgt.loadTrack(id, title, duration);
            return;
        }

        if (kzkWdgt.player.paused) {
            kzkWdgt.play(kzkWdgt.audioEpisodeId, kzkWdgt.audioEpisodeTitle);
        } else {
            kzkWdgt.pause(kzkWdgt.audioEpisodeId, kzkWdgt.audioEpisodeTitle);
        }
    },

    play: function (id, title, fullTrackDuration) {
        let promise = kzkWdgt.player.play();

        if (promise !== undefined) {
            promise.then(
                result => {
                    fullTrackDuration = parseFloat(fullTrackDuration);
                    if (isNumber(fullTrackDuration) && fullTrackDuration && isNumber(kzkWdgt.player.duration) && kzkWdgt.player.duration) {
                        if (round(fullTrackDuration) > round(kzkWdgt.player.duration)) {
                            kzkWdgt.isDemoTrack = true;
                        } else {
                            kzkWdgt.isDemoTrack = false;
                        }
                    }

                    if (kzkWdgt.playList !== null) {
                        let playBtns = kzkWdgt.playList.querySelectorAll('.play-pause-btn');
                        for (let i = 0; i < playBtns.length; i++) {
                            playBtns[i].setAttribute('class', 'play-pause-btn');
                        }

                        let trackBtn = kzkWdgt.playList.querySelector('#play-pause-btn-' + id);
                        trackBtn.setAttribute('class', 'play-pause-btn played');
                    }

                    let event = 'Play';
                    if (kzkWdgt.alreadyPlayed) {
                        event = 'Resume';
                    }

                    kzkWdgt.alreadyPlayed = true;
                    kzkWdgt.playPause.attributes.d.value = 'M0 0h6v24H0zM12 0h6v24h-6z';

                    if ('ga' in window) {
                        window.ga('main.send', 'event', 'Podcast', event, id + ' ' + title);
                    }

                    if (event === 'Play') {
                        let now = new Date();

                        for (let id in kzkWdgt.stats) {
                            if (kzkWdgt.stats.hasOwnProperty(id) && kzkWdgt.stats[id]['stop'] === undefined) {
                                kzkWdgt.stats[id]['stop'] = now.getTime() / 1000;
                            }
                        }

                        kzkWdgt.stats[id] = {
                            'audio_cycle_id': kzkWdgt.audioCycleId === 0 ? null : kzkWdgt.audioCycleId,
                            'issue_id': kzkWdgt.issueId === 0 ? null : kzkWdgt.issueId,
                            'issue_article_id': kzkWdgt.issueArticleId === 0 ? null : kzkWdgt.issueArticleId,
                            'article_id': kzkWdgt.articleId === 0 ? null : kzkWdgt.articleId,
                            'play': now.getTime() / 1000,
                            'max_time': 0
                        }
                    }
                },
                error => {
                    kzkWdgt.isDemoTrack = false;
                    kzkWdgt.makePlay();
                    kzkWdgt.pause(id, title);
                    KIOSK.openModal(kzkWdgt.playerSource.getAttribute('data-paywall'));
                }
            );
        }
    },

    pause: function (id, title) {
        if (kzkWdgt.playList !== null) {
            let playBtns = kzkWdgt.playList.querySelectorAll('.play-pause-btn');
            for (let i = 0; i < playBtns.length; i++) {
                playBtns[i].setAttribute('class', 'play-pause-btn');
            }
        }

        kzkWdgt.playPause.attributes.d.value = 'M18 12L0 24V0';
        kzkWdgt.player.pause();

        if ('ga' in window) {
            window.ga('main.send', 'event', 'Podcast', 'Pause', id + ' ' + title);
        }

        if (kzkWdgt.stats[id] !== undefined) {
            let now = new Date();
            kzkWdgt.stats[id]['stop'] = now.getTime() / 1000;
        }
    },

    loadTrack: function (id, title, duration) {
        kzkWdgt.afterEnd = false;
        kzkWdgt.player.src = '/api/' + kzkWdgt.entity + '/' + id + '?redirect=1';
        kzkWdgt.player.load();

        if (!kzkWdgt.isIos()) {
            kzkWdgt.makeLoading();
        }

        kzkWdgt.audioEpisodeId = Number(id);
        kzkWdgt.audioEpisodeTitle = title;
        kzkWdgt.audioEpisodeDuration = duration;
        kzkWdgt.alreadyPlayed = false;
    },

    selectTrack: function (id, title, duration) {
        if (kzkWdgt.playerSource.getAttribute('data-auth') !== '') {
            KIOSK.openModal(kzkWdgt.playerSource.getAttribute('data-auth'));
            return;
        }

        if (kzkWdgt.audioEpisodeId === Number(id)) {
            kzkWdgt.togglePlay();
            return;
        }

        kzkWdgt.loadTrack(id, title, duration);
    },

    makePlay: function () {
        kzkWdgt.playPauseBtn.style.display = 'flex';
        kzkWdgt.loading.style.display = 'none';
    },

    makeLoading: function () {
        kzkWdgt.playPauseBtn.style.display = 'none';
        kzkWdgt.loading.style.display = 'flex';
    },

    isIos: function() {
        let iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ];

        if (!!navigator.platform) {
            while (iDevices.length) {
                if (navigator.platform === iDevices.pop()){
                    return true;
                }
            }
        }

        return false;
    },

    sendStats: function () {
        let now = new Date();
        let c = 0;
        for (let id in kzkWdgt.stats) {
            if (kzkWdgt.stats.hasOwnProperty(id)) {
                c++;
                if (kzkWdgt.stats[id]['stop'] === undefined) {
                    kzkWdgt.stats[id]['stop'] = now.getTime() / 1000;
                }
            }
        }

        if (c === 0) {
            return;
        }

        const url = '/api-audio-episode-event';
        const data = new Blob([JSON.stringify(kzkWdgt.stats)], { type: "application/json" });

        if (navigator.sendBeacon != null) {
            navigator.sendBeacon(url, data);
        } else {
            $.ajax(url, {
                type: 'post',
                dataType: 'json',
                async: false,
                data: kzkWdgt.stats,
                success: function(e) {
                    console.log('sended');
                },
                error: function(e) {
                    console.log('not sended');
                }
            });
        }
    }
};

export default kzkWdgt;
